<template>
  <div class="content-wrapper">
    <div class="card shadow-lg border-0 p-4">
      <div class="card-body" v-if="apiComplete">
        <!-- Title -->
        <div class="text-center mb-4">
          <h2 class="fw-bold text-primary">Purchase Credits</h2>
          <p class="text-muted">Buy screening credits for internal and external screenings.</p>
        </div>



        <!-- Credit Options -->
        <div class="credit-options mt-4">
          <h4 class="text-center fw-bold">Choose Your Credits</h4>
          <div class="row g-3">
            <div class="col-md-4">
              <div class="credit-box p-3 text-center">
                <p>Quick Add</p>
                <button class="btn btn-primary w-100" @click="addCredits(5)">
                  Buy 5 Credits
                </button>
              </div>
            </div>
            <div class="col-md-4">
              <div class="credit-box p-3 text-center">
                <p>Quick Add</p>
                <button class="btn btn-primary w-100" @click="addCredits(10)">
                  Buy 10 Credits
                </button>
              </div>
            </div>
            <div class="col-md-4">
              <div class="credit-box p-3 text-center">
                <label class="fw-bold">Custom Credits</label>
                <app-input type="number" class="form-control mb-2" v-model="credits.custom" />
                <button class="btn btn-outline-primary w-100" @click="addCredits(credits.custom)">
                  Buy {{ credits.custom }} Credits
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Cart & Purchase -->
        <div class="cart-section mt-5 p-4 rounded shadow-sm">
          <h3 class="text-center text-success">Credits in Your Cart</h3>
          <p class="text-center">Total Credits: <strong>{{ credits.total_credits || 0 }}</strong></p>
          <p class="text-center">Total Amount: <strong>{{ credits.price }} £</strong></p>
          <button class="btn btn-success w-100 mt-3" @click="submit">
            Purchase Now
          </button>
        </div>
        <!-- Screening Details -->

      </div>
      <div class="row g-4">
        <div class="col-md-6">
          <div class="screening-box p-3 rounded shadow-sm">
            <h5 class="fw-bold">Internal Screening</h5>
            <p>{{ credits.Internal_Screening.Description }}</p>
            <p class="price-tag">{{ credits.Internal_Screening.Price }} £</p>
            <!--              <p class="rate-tag">Rate: {{ credits.Internal_Screening.rate }}</p>-->
          </div>
        </div>
        <div class="col-md-6">
          <div class="screening-box p-3 rounded shadow-sm">
            <h5 class="fw-bold">External Screening</h5>
            <p>{{ credits.External_Screening.Description }}</p>
            <p class="price-tag">{{ credits.External_Screening.Price }} £</p>
            <!--              <p class="rate-tag">Rate: {{ credits.External_Screening.rate }}</p>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin";
import { Credits } from "@Views/Screening/utility/apiAgent";

export default {
  name: "ScreeningCredits",
  mixins: [FormMixin],
  data() {
    return {
      credits: {
        total_credits: 0,
        custom: 0
      },
      apiComplete: false
    };
  },
  created() {
    this.setCredits();
  },
  methods: {
    setCredits() {
      Credits.getCredits().then(({ data }) => {
        this.credits.Internal_Screening = data.data["Internal Screening"];
        this.credits.External_Screening = data.data["External Screening"];
        this.apiComplete = true;
      });
    },
    addCredits(credits) {
      this.credits.total_credits += Number(credits);
      this.credits.price = this.credits.total_credits * 1;
    },
    submit() {
      const body = {
        total_credits: this.credits.total_credits,
        price: this.credits.price
      };
      Credits.postCredit(body).then(({ data }) => {
        this.$toastr.s(data.message);
        setTimeout(() => {
          window.location = "/buyer/personal/invoice";
        }, 2000);
      });
    }
  }
};
</script>

<style scoped>
/* General Styles */
.content-wrapper {
  max-width: 800px;
  margin: auto;
}

/* Screening Box */
.screening-box {
  background: #f8f9fa;
  border-left: 5px solid #007bff;
}

.price-tag {
  font-size: 1.2rem;
  font-weight: bold;
  color: #007bff;
}

.rate-tag {
  font-size: 0.9rem;
  color: #6c757d;
}

/* Credit Options */
.credit-options .credit-box {
  background: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 10px;
}

.credit-box button {
  transition: 0.3s ease;
}

.credit-box button:hover {
  transform: scale(1.05);
}

/* Cart Section */
.cart-section {
  background: #e9f7ef;
  border-left: 5px solid #28a745;
}

.btn-success {
  font-size: 1.2rem;
  font-weight: bold;
}
</style>
